export const VERIFY_REGISTER_TOKEN_REQUEST = 'VERIFY_REGISTER_TOKEN_REQUEST'
export const VERIFY_REGISTER_TOKEN_FAIL = 'VERIFY_REGISTER_TOKEN_FAIL'
export const VERIFY_REGISTER_TOKEN_SUCCESS = 'VERIFY_REGISTER_TOKEN_SUCCESS'
